module.exports = __webpack_public_path__ + "static/media/introParentsHappy2025.069998a2.png";